module.exports = __webpack_public_path__ + "static/media/svg-2.97c56ba0.svg";